import React from "react";
import PropTypes from "prop-types";

import { useHistory } from "react-router-dom";

import { Column, Field, Control, Label } from "rbx";

import {
  EmployeeSelect,
  SystemCodeSelect,
  BookingCodeSelect,
  DateInput
} from "../../../components/inputs";

const BookingHistoryFilters = ({ disabled, state, handleChange }) => {
  const history = useHistory();
  const bkWhere = {};
  if (state.CodeCatgRecIdRef !== "0") {
    bkWhere.CodeCatgRecIdRef = parseInt(state.CodeCatgRecIdRef);
  }
  return (
    <Column.Group>
      <Column>
        <Field>
          <Control>
            <Label>Employee</Label>
            <EmployeeSelect
              disabled={disabled}
              icon="user"
              name="employeeRecId"
              value={state.employeeRecId}
              onChange={({ target: { name, value } }) => {
                handleChange({ target: { name, value } });
                history.replace(`/dispatch/bookings/${value}`);
              }}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <SystemCodeSelect
              disabled={disabled}
              icon="book-open"
              label="Category"
              lookup={{ Category: "BookingCodes", CodeName: "BookCatg" }}
              name="CodeCatgRecIdRef"
              value={state.CodeCatgRecIdRef}
              onChange={({ target: { name, value } }) =>
                handleChange({ target: { name, value } })
              }
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Booking Code</Label>
            <BookingCodeSelect
              defaults={{ label: "All", value: "" }}
              disableDefaults={false}
              disabled={disabled}
              icon="book-open"
              name="BookingCodeRecIdRef"
              value={state.BookingCodeRecIdRef}
              where={bkWhere}
              onChange={({ target: { name, value } }) =>
                handleChange({ target: { name, value } })
              }
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              disabled={disabled}
              name="startDate"
              value={state.startDate}
              onChange={handleChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>End Date</Label>
            <DateInput
              disabled={disabled}
              name="endDate"
              value={state.endDate}
              onChange={handleChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  );
};

BookingHistoryFilters.propTypes = {
  state: PropTypes.object,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool
};

BookingHistoryFilters.defaultProps = {
  disabled: false
};

export default BookingHistoryFilters;
